import { render } from "./SubscriptionInvoices.vue?vue&type=template&id=22a49a1f"
import script from "./SubscriptionInvoices.vue?vue&type=script&lang=js"
export * from "./SubscriptionInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__